import { useEffect } from 'react';

/** Paired with the `body.clip-review-theater` rules in ui/workspace.scss. */
const THEATER_CLASS = 'clip-review-theater';

/**
 * Hands the app chrome the review screen's palette for as long as a review page
 * is open. A review screen fills the viewport, so on a dark desktop the white
 * header above it read as a separate page sitting on top of this one.
 */
export function useClipReviewTheater(): void {
  useEffect(() => {
    document.body.classList.add(THEATER_CLASS);

    return () => {
      document.body.classList.remove(THEATER_CLASS);
    };
  }, []);
}
